var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 11 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.23,
    height: 1.5,
    x: -0.87,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 0.61,
    transform: "scale(-1 1) rotate(-45 12.32 17.54)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.23,
    height: 1.5,
    y: 0.87,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 0.61,
    transform: "scale(-1 1) rotate(45 -4.27 -9.44)"
  })));
};
export default SvgArrowLeft;